// | ------------------------------------------------------------------------
// | Bootstrap - Popovers
// | ------------------------------------------------------------------------ 

import '@popperjs/core'
import { Popover } from "bootstrap";
import ClassWatcher from '../classes/classWatcher';

// | ------------------------------------------------------------------------ 


// Enable popovers

document.addEventListener( 'DOMContentLoaded', function() {

    if(document.querySelectorAll('[data-bs-toggle="popover"]').length > 0){ 
        var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
        var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
          return new Popover(popoverTriggerEl)
        })
    }    

});


// If mobile navigation is open then close all popovers

function hidePopovers(){

    if(document.querySelectorAll('[data-bs-toggle="popover"]').length > 0){
        var popovers = document.querySelectorAll('[data-bs-toggle="popover"]');
        popovers.forEach(function(e){
            var popover = Popover.getInstance(e)
            popover.hide();
        });           
    }

}

let popoverWatcher = new ClassWatcher(document.body, 'mobile-nav-open', hidePopovers, () => null);
